import { useAtom } from "jotai";
import { useCallback, useState } from "react";
import { catalogDbAtom } from "../../features/catalogs/catalog.state";
import { Catalog } from "../../features/catalogs/catalogs";
import { storeDbAtom } from "../../features/stores/store.state";
import { OutputForkSurface } from "../../features/catalogs/outputFork";
import { CatalogPublishModal } from "./CatalogPublishDialog";
import {
  CatalogSelectModalParams,
  OpenCatalogSelectModalFunc,
  CatalogSelectModal,
} from "./CatalogSelectDialog";
import { CatalogShareModal } from "./CatalogShareDialog";

function useCatalogShareModal() {
  const [catalog, setCatalog] = useState<Catalog>();

  const openCatalogShareModal = (c: Catalog) => setCatalog(c);
  const renderCatalogShareModal = useCallback(() => {
    if (!catalog) return null;

    return (
      <CatalogShareModal
        catalog={catalog}
        isOpen={!!catalog}
        onClose={() => setCatalog(null)}
      />
    );
  }, [catalog]);

  return { renderCatalogShareModal, openCatalogShareModal };
}

function useCatalogSelectModal() {
  const [selectParams, setSelectParams] = useState<CatalogSelectModalParams>();
  const [catalogs] = useAtom(catalogDbAtom);

  const openCatalogSelectModal: OpenCatalogSelectModalFunc = (params) => {
    setSelectParams(params);
  };

  const renderCatalogSelectModal = useCallback(() => {
    if (!selectParams) return null;

    return (
      <CatalogSelectModal
        isOpen={!!selectParams}
        onClose={() => setSelectParams(null)}
        catalogs={catalogs}
        {...selectParams}
      />
    );
  }, [catalogs, selectParams]);

  return { renderCatalogSelectModal, openCatalogSelectModal };
}

function useCatalogPublishModal(
  onChange: (catalog: Catalog) => void,
  forkSurface?: OutputForkSurface
) {
  const [catalog, setCatalog] = useState<Catalog>();
  const [storeDb] = useAtom(storeDbAtom);

  const openCatalogPublishModal = (c: Catalog) => setCatalog(c);

  const renderCatalogPublishModal = useCallback(() => {
    if (!catalog) return null;

    return (
      <CatalogPublishModal
        catalog={catalog}
        isOpen={!!catalog}
        onClose={() => setCatalog(null)}
        onChange={onChange}
        stores={storeDb.stores}
        forkSurface={forkSurface}
      />
    );
  }, [catalog, forkSurface, onChange, storeDb.stores]);

  return { renderCatalogPublishModal, openCatalogPublishModal };
}

export { useCatalogShareModal, useCatalogSelectModal, useCatalogPublishModal };
